// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { hideElementOnPrint, xScreen } from "@ces/XDL/Utilities";
import { cookiePrivacyPolicyPopupStyles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import { css } from "styled-components";

cookiePrivacyPolicyPopupStyles.drawer = {
    position: "bottom",
    size: 100,
    cssOverrides: {
        scrim: css`
            background-color: transparent;

            ${xScreen("lte", "sm")} {
                height: 200px;
            }
        `,
        drawerTitle: css`
            display: none;
        `,
        drawerContent: css`
            padding: 12px;
            margin: 0 auto;
            width: 100%;
        `,
        drawerBody: css`
            justify-content: center;
            ${hideElementOnPrint}

            ${xScreen("lte", "sm")} {
                height: 200px;
            }
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

cookiePrivacyPolicyPopupStyles.container = {
    gap: 10,
    css: css`
        margin: 0 auto;
        padding: 0 34px;
        ${xScreen("lte", "md")} {
            padding: 0 31px;
        }

        ${xScreen("lte", "sm")} {
            padding: 0 16px;
        }
        ${hideElementOnPrint}
    `,
};
cookiePrivacyPolicyPopupStyles.messageGridItem = {
    css: css`
        width: auto;
        flex-basis: auto;
        max-width: 70%;
        ${xScreen("lte", "md")} {
            max-width: 60%;
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
            max-width: none;
        }
    `,
};
cookiePrivacyPolicyPopupStyles.closeButton = {
    css: css`
        width: 100%;
    `,
    variant: "secondary",
};

cookiePrivacyPolicyPopupStyles.acceptButton = {
    css: css`
        width: auto;

        ${xScreen("lte", "sm")} {
            width: 100%;
            white-space: nowrap;
        }
    `,
};

cookiePrivacyPolicyPopupStyles.closeGridItem = {
    css: css`
        &&& {
            width: auto;
            flex-basis: auto;
            max-width: none;

            ${xScreen("lte", "sm")} {
                flex: 1;
            }
        }
    `,
};

cookiePrivacyPolicyPopupStyles.acceptGridItem = {
    css: css`
        &&& {
            width: auto;
            flex-basis: auto;
            max-width: none;
            margin-left: auto;

            ${xScreen("lte", "sm")} {
                margin: 0;
                flex: 1;
            }
        }
    `,
};

cookiePrivacyPolicyPopupStyles.messageText = {
    variant: "p",
    css: css`
        margin-bottom: 0;
    `,
};
